/**
 * Main module entities for the AI-Powered Tweet Generator.
 * These entities are shared across presentation, domain hooks, and API layers.
 */

export enum TweetTone {
  PROFESSIONAL = "professional",
  FRIENDLY = "friendly",
  HUMOROUS = "humorous",
  INSPIRATIONAL = "inspirational",
  URGENT = "urgent",
}

export enum TweetLength {
  SHORT = "short",
  MEDIUM = "medium",
  NEAR_MAX = "near_max",
}

/**
 * Represents a generated tweet stored per user.
 * All tweets must respect the 280-char limit.
 */
export interface Tweet {
  id: string;
  userId: string;

  // Inputs used to generate the tweet
  topic: string;
  tone: TweetTone;
  audience: string;
  keywords: string | null; // Comma-separated list or null when absent
  length: TweetLength;

  // Resulting content and metadata
  content: string; // <= 280 chars always enforced by server
  charCount: number; // Derived from content length at generation time

  // Bookkeeping
  createdAt: Date;
  updatedAt: Date | null;
}